export function areShallowEqual(a, b) {
    // same object
    if (a === b) {
        return true;
    }
    else if (typeof a === "string" ||
        typeof b === "string" ||
        !a || !b) {
        return a === b;
    }
    // compare shallow
    for (let i in a) {
        if (i in b) {
            if (a[i] !== b[i]) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    for (let i in b) {
        if (i in a) {
            if (a[i] !== b[i]) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=are-shallow-equal.js.map